import { createStore } from 'vuex'

export default createStore({
  state: {
    paises: [],
    paisesFiltrados: []
  },
  mutations: {
    setPaises(state, payload) {
      state.paises = payload
    },
    setPaisesFiltrados(state, payload) {
      state.paisesFiltrados = payload
    }
  },
  actions: {
    async getPaises({commit}){
      try {
        const res = await fetch('https://restcountries.com/v3/all')
        const data = await res.json()
        commit('setPaises', data)
      } catch (error) {
        console.log(error)
      }
    },
    async filterByRegion({commit, state}, region = '') {
      state.paisesFiltrados = []
      const filtro = await state.paises.filter(pais => {
        return pais.region.includes(region)
      })
      commit('setPaisesFiltrados', filtro)
    },
    async filterByName({commit, state}, name = '') {
      state.paisesFiltrados = []
      const countryName = name.toLowerCase();
      const filtro = await state.paises.filter(pais => {
        const countryNameOnline = pais.name.common.toLowerCase()
        if (countryNameOnline.includes(countryName)) {
          return pais
        }
      })
      commit('setPaisesFiltrados', filtro)
    }
  },
  getters: {
    topPaises(state) {
      return state.paisesFiltrados.sort((a, b) => {
        return a.population < b.population ? 1 : -1;
      })
    }
  },
  modules: {
  }
})
